// eslint-disable-next-line
const isAuthenticationEnabled = JSON.parse(process.env.VUE_APP_authentication_enabled);
const tazDetailsUrl = process.env.VUE_APP_tazDetailsUrl

export default [{
        path: "/",
        meta: { authRequired: isAuthenticationEnabled },
        component: resolve => require(['@layouts/main.vue'],  resolve),                              
        redirect: 'dashboard',
        children: [{
            path: 'dashboard',
            component: resolve => require(['@/pages/Dashboard.vue'],  resolve),                              
            name: 'Dashboard',
        },
        {
            path: 'ui-element',
            component:  resolve => require(['@pages/ui-element/ui-element.vue'],  resolve),                              
            name: 'ui-element',
        },
        {
            path: 'partners/index',
            component:  resolve => require(['@pages/Partners/Index.vue'],  resolve),                              
            name: 'partnersIndex',
        },
        {
            path: "partner/create",
            component:  resolve => require(['@pages/Partners/EditPartners.vue'],  resolve),                               
            name: "partnersCreate",
            props: true,
        },
        {
            path: "partner/edit/:partnerID",
            component:  resolve => require(['@pages/Partners/EditPartners.vue'],  resolve),                              
            name: "partnersEdit",
            props: true,
        },
        {
            path: 'campaigns/index',
            component:  resolve => require(['@pages/Campaigns/Index.vue'],  resolve),                              
            name: 'campaignsIndex',
            props: true,
        },
        {
            path: 'campaign/create',
             component: resolve => require(['@pages/Campaigns/EditCampaigns.vue'],  resolve),
            name: 'campaignsCreate',
            children: [{
                    path: "details",
                    component: resolve => require(['@components/campaign/campaignDetails.vue'],  resolve),
                    props: true,
                    name: "campaignDetails",
                },
                {
                    path: "attributes",
                    ccomponent: resolve => require(['@components/campaign/callAttributes/CallAttributes.vue'],  resolve),
                    props: true,
                    name: "CallAttributes",
                },
                {
                    path: "details/:partnerID",
                    component: resolve => require(['@components/campaign/campaignDetails.vue'],  resolve),
                    props: true,
                    name: "campaignDetailsWithPartner",
                },
            ]
        },
        {
            path: 'campaign/edit/:campaignID',
            component: resolve => require(['@pages/Campaigns/EditCampaigns.vue'],  resolve),
            props: true,
            name: 'campaignsEdit',
            children: [{
                    path: "details",
                    component: resolve => require(['@components/campaign/campaignDetails.vue'],  resolve),
                    props: true,
                    name: "campaignDetailsEdit",
                },
                {
                    path: "assigncallpath",
                    component: resolve => require(['@components/campaign/AssignCallPath.vue'],  resolve),
                    props: true,
                    name: "assigncallpath",
                },
                {
                    path: "assigncallpath/:cloneCampaignID",
                    component: resolve => require(['@components/campaign/AssignCallPath.vue'],  resolve),
                    props: true,
                    name: "assigncallpathClone",
                },
                {
                    path: "assigncallpath/callpath/:callPathID",
                    component: resolve => require(['@components/campaign/AssignCallPath.vue'],  resolve),
                    props: true,
                    name: "assigncallpathSelected",
                },
                {
                    path: "attributes",
                    component: resolve => require(['@components/campaign/callAttributes/CallAttributes.vue'],  resolve),
                    props: true,
                    name: "EditCallAttributes",
                },
                {
                    path: "attributes/:cloneCampaignID",
                    component: resolve => require(['@components/campaign/callAttributes/CallAttributes.vue'],  resolve),
                    props: true,
                    name: "callAttributesClone",
                },
            ]
        },
        {
            path: 'campaign/clone/:isClone/campaignID/:campaignID',
             component: resolve => require(['@pages/Campaigns/EditCampaigns.vue'],  resolve),
            props: true,
            name: 'campaignClone',
            children: [{
                path: "details",
                component: resolve => require(['@components/campaign/campaignDetails.vue'],  resolve),
                props: true,
                name: "campaignDetailsClone",
            }, ]
        },
        {
            path: 'callpaths/index',
             component: resolve => require(['@pages/CallPaths/Index.vue'],  resolve),
            name: 'callPathsIndex',
            props: true,
        },
        {
            path: 'callpath/create',
             component: resolve => require(['@pages/CallPaths/EditCallPaths.vue'],  resolve),
            name: 'callpathCreate',
            props: true,
        },
        {
            path: 'callpath/create/:campaignID',
             component: resolve => require(['@pages/CallPaths/EditCallPaths.vue'],  resolve),
            name: 'callpathCreateCampaignID',
            props: true,
        },
        {
            path: "callpath/edit/:callPathID",
             component: resolve => require(['@pages/CallPaths/EditCallPaths.vue'],  resolve),
            name: "callPathEdit",
            props: true,
        },
        {
            path: "callpath/clone/:isClone/callPathID/:callPathID",
             component: resolve => require(['@pages/CallPaths/EditCallPaths.vue'],  resolve),
            name: "callPathClone",
            props: true,
        },
        {
            path: "callpath/clone/:isClone/callPathID/:callPathID/campaignID/:campaignID",
             component: resolve => require(['@pages/CallPaths/EditCallPaths.vue'],  resolve),
            name: "clonedCallPath",
            props: true,
        },
        {
            path: 'callprompts/index',
             component: resolve => require(['@pages/CallPrompts/Index.vue'],  resolve),
            name: 'callPromptsIndex',
        },
        {
            path: "callprompt/create",
             component: resolve => require(['@pages/CallPrompts/EditCallPrompts.vue'],  resolve),
            name: "createCallPrompts",
            props: true,
        },
        {
            path: "callprompt/edit/:promptID",
             component: resolve => require(['@pages/CallPrompts/EditCallPrompts.vue'],  resolve),
            name: "editCallPrompts",
            props: true,
        },
        {
            path: "prompts/clone/:isClone/promptID/:promptID",
             component: resolve => require(['@pages/CallPrompts/EditCallPrompts.vue'],  resolve),
            name: "cloneCallPrompts",
            props: true,
        },
        {
            path: 'filters/index',
             component: resolve => require(['@pages/Filters/Index.vue'],  resolve),
            name: 'filtersIndex',
        },
        {
            path: "filters/create",                
            component: resolve => require(['@pages/Filters/EditFilter.vue'],  resolve),
            name: "filtersCreate",
            props: true,
        },
        {
            path: "filters/edit/:filterID",                
            component: resolve => require(['@pages/Filters/EditFilter.vue'],  resolve),
            name: "filtersEdit",
            props: true,
        },          
        {
            path: 'reporting/calllogreport',
             component: resolve => require(['@components/reports/callLog.vue'],  resolve),
            props: true,
            name: 'reportCallLog',
        },
        {
            path: 'reporting/affiliatesummaryreport',
             component: resolve => require(['@components/reports/affiliateSummaryReport.vue'],  resolve),
            props: true,
            name: 'affiliateSummaryReport',
        },
        {
            path: 'reporting/affiliatelogreport',
             component: resolve => require(['@components/reports/affiliateLogReport.vue'],  resolve),
            props: true,
            name: 'affiliatelogReport',
        },
        {
            path: "blockednumbers",                
            component: resolve => require(['@pages/BlockedNumbers/BlockedNumbers.vue'],  resolve),
            name: "blockednumbers",
            props: true,
        },
        {
            path: 'support',
            component: resolve => require(['@pages/Support'],  resolve),
            name: 'supportIndex',
        },
        {
            path: 'testpage',
            component: resolve => require(['@pages/TestPage'],  resolve),
            name: 'testpage',
        },
        {
            path: 'directmail/create',
            component:  resolve => require(['@pages/DirectMail/EditDirectMail.vue'],  resolve),                              
            props: true,
            name: 'directMailReportLogCreate',
        },
        {
            path: "directmail/edit/:directMailID",
            component:  resolve => require(['@pages/DirectMail/EditDirectMail.vue'],  resolve),                              
            name: "directMailEdit",
            props: true,
        },
        {
            path: "directmail/clone/:isClone/directMailID/:directMailID",
            component:  resolve => require(['@pages/DirectMail/EditDirectMail.vue'],  resolve),                              
            name: "directMailClone",
            props: true,
        },
        {
            path: 'directmail/index',
            component:  resolve => require(['@pages/DirectMail/Index.vue'],  resolve),                              
            name: 'directMailIndex',
        },
        {
            path: "/tazdetails",
            name: 'tazdetails',
            beforeEnter() {
              window.open(tazDetailsUrl);
            }
        },
        {
            path: "holidayschedule", 
            component:  resolve => require(['@pages/HolidaySchedule/HolidaySchedule.vue'], resolve),                              
            name: "holidayschedule",
            props: true,
        },  
        {
            path: "auditlog",       
            component:  resolve => require(['@pages/AuditLog/AuditLog.vue'], resolve),             
            name: "auditlog",
            props: true,
        },
        {
            path: "userrole",   
            component:  resolve => require(['@pages/UserRole/UserRole.vue'], resolve),                       
            name: "userrole",
            props: true,
        },
        {
            path: 'reporting/inboundpingpostdetails',
             component: resolve => require(['@components/reports/inboundPingPostDetailsReport.vue'],  resolve),
            props: true,
            name: 'inboundPingPostDetailsReport',
        },
        ]
    },    
    {
        path: '/login',
        name: 'login',
        component:  resolve => require(['@pages/global/Login'],  resolve),               
        meta: {
          authRequired: false,
        },
    },
    {
        path: '/health',
        name: 'health',
        component:  resolve => require(['@pages/global/health'],  resolve),                              
        meta: {
          authRequired: false,
        },
    },
    {
        path: '/logged-out',
        name: 'logged_out',
        component: resolve => require(['@pages/global/LoggedOut'],  resolve),                              
        meta: {
          authRequired: false,
        },
    },
    {
        path: '/callback',
        name: 'callback',
        component: resolve => require(['@pages/global/Callback'],  resolve),                              
        meta: {
          authRequired: false,
        },
    },
    //Root
    {
        path: '',
        meta: { authRequired: isAuthenticationEnabled },
        name: 'report_dashboard',
        component:  resolve => require(['@pages/Dashboard'],  resolve)
    },
    {
        path: '/',
        name: 'landing_page',
        component:  resolve => require(['@pages/global/loading'],  resolve),
        meta: {
            authRequired: isAuthenticationEnabled,
            beforeResolve(routeTo, routeFrom, next) {
            next({
                name: 'Dashboard',
            });
            },
        },
    },
    {
        path: '/404',
        name: '404',
        component: resolve => require(['@pages/global/404'],  resolve),
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
    },
    {
        path: '*',
        redirect: '404',
    },
];